module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="modal-dialog">\n    <button type="button" class="close" aria-hidden="true">&times;</button>\n    <div class="modal-content"></div>\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/dialog/dialog.tpl
 ** module id = 881
 ** module chunks = 1 2 108
 **/